import React, { Component } from 'react';
import style from './style/foldout.scss';

/** FoldOut Component
 *
 * Component whose contents can be toggled using the provided arrow icon and an optional label
 *
 * note: if no contents (children) were received, there will not be a click action or toggle button visible
 * note: you can override styles on the root element (and further down) using the classes object
 *
 * @example
 * <FoldOut label={ 'here goes the optional label' } classes={{ root: { backgroundColor: 'purple' } }}>
 *     the actual content goes here
 * </FoldOut>
 */

class FoldOut extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };

        this.toggleSection = this.toggleSection.bind(this);
    }

    toggleSection() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const { children, label = '', classes = { root: {}, foldOut: {} }, icons } = this.props;
        let button;

        if (icons) {
            button = this.state.open ? icons.open : icons.closed;
        } else {
            button = <button>
                { `${this.state.open ? '˄' : '˅'}`}
            </button>;
        }

        return (<section
            tabIndex="-1"
            className={ `${style.foldout} ${classes.foldOut ? classes.foldOut : ''}` }
            style={ classes.root }
            onClick={ children ? this.toggleSection : null }
        >
            <header>
                { icons ? <h5>{ label }</h5> : <span>{ label }</span> }
                { children
                    ? button
                    : null
                }
            </header>

            <div className={ `${style.foldout_content} ${this.state.open ? style.foldout__open : ''}` }>
                { children }
            </div>
        </section>);
    }
}

export default FoldOut;
